import apiClient from '@/services/axios'
import { transformIntoQuery } from '@/utils/pagination'

class AdminUserBuyerService {
  constructor() {
    this.$api = apiClient
  }

  getUsers (pagination, sort, filter) {
    const query = transformIntoQuery(pagination, sort, filter)
    return this.$api.get(`/admin/buyers${query}`)
  }

  getUser (userId) {
    return this.$api.get(`/admin/buyers/${userId}`)
  }

  getUserOrders (userId, pagination, sort, filter) {
    const query = transformIntoQuery(pagination, sort, filter)
    return this.$api.get(`/admin/buyers/${userId}/orders${query}`)
  }

  getUserSessions(userId) {
    return this.$api.get(`/admin/buyers/${userId}/active-sessions`)
  }

  postUser (payload, companyId) {
    return this.$api.post(`/admin/seller-buyers?company_id=${companyId}`, payload)
  }

  terminateUserSession(userId, token) {
    return this.$api.patch(`/admin/buyers/${userId}/active-sessions/${token}/close`)
  }

  toggleBlocking(userId) {
    return this.$api.patch(`/admin/buyers/${userId}/toggle-block`)
  }

  toggleActivity(userId) {
    return this.$api.patch(`/admin/buyers/${userId}/toggle-activity`)
  }
}

export default new AdminUserBuyerService()
